// extracted by mini-css-extract-plugin
export default {"l":"_54b09b8ac4"};